import {__} from '@wordpress/i18n';

export const attributes = {
	requestQuoteButtonLabel: {
		type: 'string',
		default: __('Request shipping quote', 'woocommerce-contact-for-shipping-quote'),
	},
	quoteRequestedText: {
		type: 'string',
		default: __('Your shipping quote is requested.', 'woocommerce-contact-for-shipping-quote'),
	},
	refreshLabel: {
		type: 'string',
		default: __('Refresh', 'woocommerce-contact-for-shipping-quote'),
	},
}
